var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"taption-privacy",attrs:{"name":"termly-embed","data-id":"2275745e-4237-48ce-83a9-917dfd6e7b3a","data-type":"iframe"}})
}
var staticRenderFns = []

export { render, staticRenderFns }